import React from 'react';
import Buyerszonelist from '../components/Buyerszone/Buyerszonelist';
import { useNavigate, useParams } from 'react-router-dom';
function Buyerszone() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/`);  // Navigate with query param & path, query, key=value pair
  };
  return (
    <div className="page-container"> {/* Use className */} 
      <h2 className="poems__title_painting"><span><a href="#" onClick={(e) => handleClick()}><img src={require('../assets/images/back.png')} style={{ width: 25 }} /></a></span>Buyer's Zone</h2>
      <Buyerszonelist />
    </div>
  );

}

export default Buyerszone; 